var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_chiudi",
    "data-name": "icona chiudi",
    transform: "translate(-399.5 -138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(400 138.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M4.5,18h9.429",
    transform: "translate(2.071 -13.697)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M4.5,27h9.429",
    transform: "translate(2.071 -19.303)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "freccia",
    d: "M16.357,9,13.5,11.857l2.857,2.857Z",
    transform: "translate(-13.5 -6.214)",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M4.5,9h16",
    transform: "translate(-4.5 -9)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M4.5,27h16",
    transform: "translate(-4.5 -15)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/close_menu.f2e6eda8471afea1c6ba5f86aed79ffc.svg";
export { ForwardRef as ReactComponent };